(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[347],{

/***/ "v5/V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Instagram", function() { return Instagram; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var Instagram = function Instagram(_ref) {
  var title = _ref.title,
      rest = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["title"]);

  return __jsx("svg", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    viewBox: "0 0 494 494"
  }, rest), title && __jsx("title", null, title), __jsx("path", {
    d: "M247 45.1c65.4 0 73.2.2 99 1.4 23.9 1.1 36.9 5.1 45.5 8.4 11.4 4.4 19.6 9.8 28.2 18.3 8.6 8.6 13.9 16.7 18.3 28.2 3.4 8.6 7.3 21.6 8.4 45.5 1.2 25.8 1.4 33.6 1.4 99s-.2 73.2-1.4 99c-1.1 23.9-5.1 36.9-8.4 45.5-4.4 11.4-9.8 19.6-18.3 28.2-8.6 8.6-16.7 13.9-28.2 18.3-8.6 3.4-21.6 7.3-45.5 8.4-25.8 1.2-33.6 1.4-99 1.4s-73.2-.2-99-1.4c-23.9-1.1-36.9-5.1-45.5-8.4-11.4-4.4-19.6-9.8-28.2-18.3-8.6-8.6-13.9-16.7-18.3-28.2-3.4-8.6-7.3-21.6-8.4-45.5-1.2-25.8-1.4-33.6-1.4-99s.2-73.2 1.4-99c1.1-23.9 5.1-36.9 8.4-45.5 4.4-11.4 9.8-19.6 18.3-28.2 8.6-8.6 16.7-13.9 28.2-18.3 8.6-3.4 21.6-7.3 45.5-8.4 25.8-1.1 33.6-1.4 99-1.4M247 1c-66.5 0-74.9.3-101 1.5-26.1 1.2-43.9 5.3-59.5 11.4-16.1 6.3-29.8 14.6-43.4 28.3-13.6 13.6-22 27.3-28.3 43.4-6 15.5-10.1 33.3-11.3 59.4C2.3 171.1 2 179.5 2 246s.3 74.9 1.5 101c1.2 26.1 5.3 43.9 11.4 59.5 6.3 16.1 14.6 29.8 28.3 43.4 13.6 13.6 27.3 22 43.4 28.3 15.6 6.1 33.4 10.2 59.5 11.4 26.1 1.2 34.5 1.5 101 1.5s74.9-.3 101-1.5c26.1-1.2 43.9-5.3 59.5-11.4 16.1-6.3 29.8-14.6 43.4-28.3 13.6-13.6 22-27.3 28.3-43.4 6.1-15.6 10.2-33.4 11.4-59.5 1.2-26.1 1.5-34.5 1.5-101s-.3-74.9-1.5-101c-1.2-26.1-5.3-43.9-11.4-59.5-6.3-16.1-14.6-29.8-28.3-43.4-13.6-13.6-27.3-22-43.4-28.3-15.7-6-33.5-10.1-59.6-11.3C321.9 1.3 313.5 1 247 1z"
  }), __jsx("path", {
    d: "M245 119.2c-69.5 0-125.8 56.3-125.8 125.8S175.5 370.8 245 370.8 370.8 314.5 370.8 245 314.5 119.2 245 119.2zm0 207.5c-45.1 0-81.7-36.6-81.7-81.7s36.6-81.7 81.7-81.7 81.7 36.6 81.7 81.7-36.6 81.7-81.7 81.7z"
  }), __jsx("circle", {
    cx: 375.8,
    cy: 114.2,
    r: 29.4
  }));
};

/***/ })

}]);